<template>
  <div class="container dark">
    <h1>{{ clientName }}</h1>
    <span class="subtitle">{{ name }}</span>
    <span class="baseline" v-html="$t('masthead.baseline')"></span>
  </div>
</template>

<script>
export default {
  props: ['data'],

  computed: {
    name() {
      return this.data.name;
    },

    clientName() {
      return this.data.clientName;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url('./../../assets/brushred.png');
  background-repeat: no-repeat;
  background-position: 0 50%;
  background-size: auto 100%;
}
.subtitle {
  color: colors.$earth-color;
  display: block;
  font-size: 2.125em;
  padding-top: 0.5em;
  text-align: center;

  &:after {
    content: '';
    display: block;
    margin: auto;
    width: 5.2941176471em;
    height: 1px;
    background-color: colors.$main-color;
    margin-top: 2em;
    margin-bottom: 2.9411764706em;
  }
}
.baseline {
  font-size: 2.5em;
  text-align: center;
}
</style>
